import { render, staticRenderFns } from "./DonorInformation.vue?vue&type=template&id=ec5b6638&scoped=true"
import script from "./DonorInformation.vue?vue&type=script&lang=js"
export * from "./DonorInformation.vue?vue&type=script&lang=js"
import style0 from "./DonorInformation.vue?vue&type=style&index=0&id=ec5b6638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5b6638",
  null
  
)

export default component.exports